import { createReducer, on } from '@ngrx/store';
import { NavigationState } from '../states/navigation.state';
import { ReportMenu } from '../../entities/report-menu.entity';
import * as NavigationActions from '../actions/navigation.actions';

const getSelectedRouteFromStorage = (): ReportMenu | null => {
  const storedRoute = localStorage.getItem('selectedRoute');
  if (storedRoute) {
    try {
      return JSON.parse(storedRoute);
    } catch (error) {
      console.error('Error parsing stored selected route:', error);
      localStorage.removeItem('selectedRoute');
    }
  }
  return null;
};

export const initialState: NavigationState = {
  routes: JSON.parse(localStorage.getItem('routes') || '[]'),
  selectedRoute: getSelectedRouteFromStorage(),
};

// reducer
export const navigationReducer = createReducer(
  initialState,
  on(NavigationActions.loadNavigationSuccess, (state, { routes }) => {
    localStorage.setItem('routes', JSON.stringify(routes));

    if (state.selectedRoute) {
      const routeStillExists = routes.some(route => route.uuid === state.selectedRoute?.uuid);
      if (!routeStillExists) {

        localStorage.removeItem('selectedRoute');
        return { ...state, routes, selectedRoute: null };
      }
    }

    return { ...state, routes };
  }),
  on(NavigationActions.loadNavigationFailure, (state, { error }) => ({
    ...state,
  })),
  on(NavigationActions.selectRoute, (state, { route }) => {
    localStorage.setItem('selectedRoute', JSON.stringify(route));
    return {
      ...state,
      selectedRoute: route,
    };
  }),
  on(NavigationActions.deselectRoute, (state) => {
    localStorage.removeItem('selectedRoute');
    return {
      ...state,
      selectedRoute: null,
    };
  }),
);
